import { SimpleEvent } from "../../HelperModules/SimpleEvent.js";
export class UITrack {
    constructor(name, startY, height, track) {
        this.name = name;
        this.startY = startY;
        this.height = height;
        this.track = track;
    }
    destroy() {
        this.track.destroy();
    }
    serialise() {
        return {
            type: "base",
            name: this.name,
            startY: this.startY,
            height: this.height,
            modelTrackID: this.track.id
        };
    }
}
export class NoteUITrack extends UITrack {
    constructor(settings, baseTrack) {
        super(settings.name, settings.startY, settings.height, baseTrack);
        if (settings.noteGroups != undefined) {
            this._noteGroups = settings.noteGroups;
        }
        else {
            this._noteGroups = [];
        }
        this.noteGroupsChanged = new SimpleEvent();
    }
    get noteGroups() {
        return this._noteGroups;
    }
    serialise() {
        let base = super.serialise();
        return Object.assign(Object.assign({}, base), { type: "oscillator", noteGroups: this._noteGroups });
    }
    getNoteGroupsStartingBetweenTime(startTime, endTime) {
        let noteGroupsInRange = [];
        for (let i = 0; i < this._noteGroups.length; i++) {
            let noteGroup = this._noteGroups[i];
            if (noteGroup[0] >= startTime && noteGroup[0] <= endTime) {
                noteGroupsInRange.push(noteGroup);
            }
            else if (noteGroup[0] > endTime) {
                break;
            }
        }
        return noteGroupsInRange;
    }
    getNoteGroupsWithinTime(startTime, endTime) {
        let noteGroupsToReturn = [];
        for (let i = 0; i < this._noteGroups.length; i++) {
            let noteGroup = this._noteGroups[i];
            if (noteGroup[1] > startTime && noteGroup[0] < endTime) {
                noteGroupsToReturn.push(noteGroup);
            }
            else if (noteGroup[0] > endTime) {
                break;
            }
        }
        return noteGroupsToReturn;
    }
    getNoteGroupIndex(noteGroup) {
        for (let i = 0; i < this._noteGroups.length; i++) {
            if (noteGroup[0] == this._noteGroups[i][0] && noteGroup[1] == this._noteGroups[i][1]) {
                return i;
            }
        }
        return null;
    }
    addNoteGroup(startTime, endTime) {
        if (startTime < 0 || endTime < 0) {
            throw new RangeError("StartTime and EndTime must both be greater than 0.");
        }
        if (startTime > endTime) {
            throw new RangeError("StartTime cannot be greater than endTime");
        }
        this.noteGroupsChanged.emit();
        if (this._noteGroups.length === 0) {
            this._noteGroups.push([startTime, endTime]);
            return 0;
        }
        else {
            if (endTime <= this._noteGroups[0][0]) {
                this._noteGroups.splice(0, 0, [startTime, endTime]);
                return 0;
            }
            else if (startTime >= this._noteGroups[this._noteGroups.length - 1][1]) {
                this._noteGroups.push([startTime, endTime]);
                return this._noteGroups.length - 1;
            }
            for (let i = 0; i < this._noteGroups.length - 1; i++) {
                if (startTime >= this._noteGroups[i][1] && endTime <= this._noteGroups[i + 1][0]) {
                    this._noteGroups.splice(i + 1, 0, [startTime, endTime]);
                    return i;
                }
            }
            throw new RangeError("Region invalid, likely collides with other existing region.");
        }
    }
    removeNoteGroup(startTime) {
        let left = 0;
        let right = this._noteGroups.length - 1;
        let mid = 0;
        while (left <= right) {
            mid = Math.floor((left + right) / 2);
            if (startTime - this._noteGroups[mid][0] === 0) {
                this._noteGroups.splice(mid, 1);
                this.noteGroupsChanged.emit();
                return;
            }
            else if (startTime - this._noteGroups[mid][0] > 0) {
                left = mid + 1;
            }
            else {
                right = mid - 1;
            }
        }
        throw new RangeError("Element with given startTime does not exist.");
    }
    updateNoteGroups(noteEvent) {
        if (this._noteGroups.length == 0) {
            this.addNoteGroup(noteEvent.startPosition, noteEvent.endPosition);
            return;
        }
        let noteGroups = this.getNoteGroupsWithinTime(noteEvent.startPosition, noteEvent.endPosition);
        let chosenNoteGroup = null;
        if (noteGroups.length > 1) {
            chosenNoteGroup = [noteGroups[0][0], noteGroups[noteGroups.length - 1][1]];
            noteGroups.forEach(noteGroup => {
                this.removeNoteGroup(noteGroup[0]);
            });
            this.addNoteGroup(chosenNoteGroup[0], chosenNoteGroup[1]);
        }
        else if (noteGroups.length == 1) {
            chosenNoteGroup = noteGroups[0];
        }
        else {
            if (this.noteGroups[0][0] > noteEvent.endPosition) {
                chosenNoteGroup = this.noteGroups[0];
            }
            else {
                let index = 1;
                while (index < this.noteGroups.length && this.noteGroups[index][1] < noteEvent.startPosition) {
                    index++;
                }
                if (index == this.noteGroups.length) {
                    chosenNoteGroup = this.noteGroups[index - 1];
                }
                else {
                    if (Math.abs(this.noteGroups[index - 1][1] - noteEvent.endPosition) <= Math.abs(this.noteGroups[index][0] - noteEvent.startPosition)) {
                        chosenNoteGroup = this.noteGroups[index - 1];
                    }
                    else {
                        chosenNoteGroup = this.noteGroups[index];
                    }
                }
            }
        }
        let newNoteGroup = chosenNoteGroup;
        if (newNoteGroup[0] > noteEvent.startPosition) {
            newNoteGroup[0] = noteEvent.startPosition;
        }
        if (newNoteGroup[1] < noteEvent.endPosition) {
            newNoteGroup[1] = noteEvent.endPosition;
        }
        if (newNoteGroup != chosenNoteGroup) {
            this.removeNoteGroup(chosenNoteGroup[0]);
            this.addNoteGroup(newNoteGroup[0], newNoteGroup[1]);
            this.noteGroupsChanged.emit();
        }
        else {
            this.checkNoteGroupBoundaries(this.getNoteGroupIndex(chosenNoteGroup));
        }
    }
    checkNoteGroupBoundaries(index) {
        let notes = this.getNoteGroupNotes(index);
        if (notes.length == 0) {
            this.removeNoteGroup(this._noteGroups[index][0]);
            return;
        }
        let max = notes[0].endPosition;
        for (let i = 1; i < notes.length; i++) {
            max = Math.max(max, notes[i].endPosition);
        }
        this._noteGroups[index][0] = notes[0].startPosition;
        this._noteGroups[index][1] = max;
        this.noteGroupsChanged.emit();
    }
    getNoteGroupNotes(index) {
        let noteGroup = this._noteGroups[index];
        return this.track.timeline.getEventsBetweenTimes(noteGroup[0], noteGroup[1]);
    }
    addEvent(startPosition, pitch, duration) {
        let event = this.track.addNote(startPosition, pitch, duration);
        this.updateNoteGroups(event);
        return event;
    }
    editEvent(event, startPosition, pitch, duration) {
        event.pitchString = pitch;
        this.track.timeline.editEvent(this.track.timeline.getIndexOfEvent(event), startPosition, duration);
        this.updateNoteGroups(event);
    }
    removeEvent(event) {
        let noteGroupIndex = this.getNoteGroupIndex(this.getNoteGroupsWithinTime(event.startPosition, event.endPosition)[0]);
        this.track.removeNote(event);
        this.checkNoteGroupBoundaries(noteGroupIndex);
    }
    destroy() {
        this.noteGroupsChanged.removeAllListeners();
        super.destroy();
    }
}
export class SoundFileUITrack extends UITrack {
    constructor(settings, track) {
        super(settings.name, settings.startY, settings.height, track);
        this.displayActualWidth = true;
        this.displayActualWidth = settings.displayActualWidth;
    }
    get eventDuration() {
        return this.track.soundFileDuration;
    }
    serialise() {
        let base = super.serialise();
        return Object.assign(Object.assign({}, base), { type: "soundFile", displayActualWidth: this.displayActualWidth });
    }
    getOneShotsBetweenTime(startTime, endTime) {
        return this.track.timeline.getEventsBetweenTimes(startTime, endTime);
    }
}
//# sourceMappingURL=UITrack.js.map